import { render, staticRenderFns } from "./NotificationAdmin.vue?vue&type=template&id=4a572a94&scoped=true&"
import script from "./NotificationAdmin.vue?vue&type=script&lang=js&"
export * from "./NotificationAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a572a94",
  null
  
)

export default component.exports